import React, { createContext, useContext, useReducer } from "react";
import { ACTION_TYPES, AppReducer, AppState } from "./app-reducer";
import { IApplicationData } from "models/application-data";

const AppContext = createContext<AppState | undefined>(undefined);
const AppContextDispatchContext = createContext({} as any);

const AppProvider = ({ children }: { children: React.ReactNode }) => {
    const [state, dispatch] = useReducer(AppReducer, {
        applicationData: undefined,
        menus: [],
        menusLoading: false,
        menusError: false,
        homeData: {
            news: undefined,
            linkServices: undefined,
            banners: undefined,
        },
    } as AppState);

    return (
        <AppContext.Provider value={state}>
            <AppContextDispatchContext.Provider value={dispatch}>
                {children}
            </AppContextDispatchContext.Provider>
        </AppContext.Provider>
    );
}

const useAppState = () => {
    const context = useContext(AppContext);
    if (context === undefined) {
        throw new Error('useAppState must be used within a AppProvider');
    }
    return context;
}

const useAppDispatch = () => {
    const context = useContext(AppContextDispatchContext);
    if (context === undefined) {
        throw new Error('useAppDispatch must be used within a AppProvider');
    }
    return context;
}

export { AppProvider, useAppState, useAppDispatch, ACTION_TYPES };